import React from 'react';
import Content from 'components/_ui/Content';
import styled from '@emotion/styled';
import dimensions from 'styles/dimensions';
import { Inner } from 'styles/structure';
import { Rubric } from 'styles/typography';
import Illustration from 'components/_ui/Illustration';

const ContentBlockContainer = styled.div`
  position: relative;
  display: block;
  margin: 6.4rem 0 5.6rem;
  
  header {
    margin-bottom: 5.6rem;
    text-align: center;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    margin: 12rem 0;
    
    header {
      margin-bottom: 8rem;
    }
  }
`;

const ContentBlockWrap = styled.div`
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    display: flex;
    align-items: center;
  }
`;

const ContentBlockImage = styled.div`
  display: block;
  width: 100%;
  max-width: 40rem;
  
  img {
    display: block;
    width: 100%;
  }
  
  & + * {
    margin-top: 2.4rem;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    flex: 2 1 50%;
    margin-right: 5.6vw;
  } 
  
  @media(min-width: ${dimensions.desktopUp}px) {
    max-width: none;
  }
`;

const ContentBlockContent = styled.div`
  h4 {
    & + * {
      margin-top: 1.6rem;
    }
  }
  
  > div {
    & + * {
      margin-top: 2.4rem;
    } 
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    flex: 1 1 50%;
    padding: 4rem;
    
    .ContentBlock--large & {
      p {
        font-size: 2.1rem;
      }
    }
  }
`;

const ContentBlock = ({ intro, heading, content, image, illustration, variant }) => {
  return (
    <ContentBlockContainer className={variant && `ContentBlock--${variant}`}>
      <Inner>
        {(intro || heading) && (
          <header>
            {intro && <Rubric>{intro}</Rubric>}
            {heading && <h2>{heading}</h2>}
          </header>
        )}

        <ContentBlockWrap>
          {(illustration || image) && (
          <ContentBlockImage>
            {illustration && (
              <Illustration source={illustration} poster={image}/>
            )}

            {(!illustration && image) && (
              <img src={image.url} alt={image.alt} loading="lazy" />
            )}
          </ContentBlockImage>
          )}

          <ContentBlockContent>
            {content && <Content content={content}/>}
          </ContentBlockContent>
        </ContentBlockWrap>
      </Inner>
    </ContentBlockContainer>
  );
};

export default ContentBlock;
